import { TagsPrefixType, TagsType } from "../models/types/TagsType";

const TAG_PREFIXES: Record<TagsPrefixType, string> = {
    REI: 'rei:',
    REI_UPPERCASE: 'REI:',
};

const TAGS: Record<TagsType, string> = {
    HELP: `${TAG_PREFIXES.REI}help`,
    HELP_CARD_CHAT: `${TAG_PREFIXES.REI}help_card_chat`,
    HELP_CLICK_CONTACT: `${TAG_PREFIXES.REI}help_click_to_contact`,
    HELP_CLICK_CONTACT_US: `${TAG_PREFIXES.REI}help_click_to_contact_us`,
    HELP_CLICK_SHOW_CONTACT_US: `${TAG_PREFIXES.REI}help_click_to_show_contact_us`,
    HELP_EMAIL_SUBMIT: `${TAG_PREFIXES.REI}help_email_submit`,

    HELP_CENTER: `${TAG_PREFIXES.REI}Help_Center`,
    HELP_CENTER_UPPERCASE: `${TAG_PREFIXES.REI_UPPERCASE}Help_Center`,
    HELP_CENTER_HOMEPAGE: `${TAG_PREFIXES.REI_UPPERCASE}Help_Center_Homepage`,
    HELP_CENTER_HOMEPAGE_POPULAR: `${TAG_PREFIXES.REI}Help_Center_Homepage_Popular`,
    HELP_CENTER_HOMEPAGE_MY_ORDERS: `${TAG_PREFIXES.REI}Help_Center_Homepage_My_Orders`,
    HELP_CENTER_NAVIGATION: `${TAG_PREFIXES.REI_UPPERCASE}Help_Center_Navigation`,
    HELP_CENTER_MY_ORDERS: `${TAG_PREFIXES.REI}Help_Center_Homepage_My_Orders`,
    HELP_CENTER_RELATED: `${TAG_PREFIXES.REI_UPPERCASE}Help_Center_Related`,

    HELP_CONTACT: `${TAG_PREFIXES.REI}help_contact`,
    HELP_CONTACT_QL: `${TAG_PREFIXES.REI}help_contact_ql`,
    HELP_CONTACT_PL: `${TAG_PREFIXES.REI}help_contact_pl`,
    HELP_CONTACT_STEP_TWO_SUBMIT: `${TAG_PREFIXES.REI}help_contact_step_2_submit`,
    HELP_CONTACT_CATEGORY_CHANGE: `${TAG_PREFIXES.REI}help_contact_category_change`,

    PAGE_CONTACT_US: `${TAG_PREFIXES.REI}contact-us`,
    CONTACT_US_QUICK_HELP: `${TAG_PREFIXES.REI}contact-us_quick-help`,
    DELIVERY_ISSUES: `${TAG_PREFIXES.REI}delivery_issues`,
    DELIVERY_ISSUES_CHAT: `${TAG_PREFIXES.REI}delivery_issues_chat`,
    PRICE_ADJUST: `${TAG_PREFIXES.REI}price_adjust`,
    PRICE_ADJUSTMENT_CHAT: `${TAG_PREFIXES.REI}price_adjustment_chat`,
    MEMBER_NAME_CHANGE: `${TAG_PREFIXES.REI}member_name_change`,
    MEMBER_NAME_CHANGE_CHAT: `${TAG_PREFIXES.REI}member_name_change_chat`,
    REFUND_ESTIMATE: `${TAG_PREFIXES.REI}refund_estimate`,
    REFUND_ARTICLE_CHAT: `${TAG_PREFIXES.REI}refund_article_chat`,

    HELP_CENTER_HOMEPAGE_YOUR_REWARDS_ACTIVITY_CLICK: `${TAG_PREFIXES.REI}Help_Center_Homepage_Your_Rewards_Activity`,
    MEMBERSHIP_REWARDS_LINK_MEMBERSHIP_CLICK: `${TAG_PREFIXES.REI}Help_Center_Membership_Account_Link_Membership`,

    // A/B tests
    HELP_CENTER_MEMBER_INFO_CONTROL: `${TAG_PREFIXES.REI}Help_Center_Member_Info_Control`,
    HELP_CENTER_MEMBER_INFO_VARIANT: `${TAG_PREFIXES.REI}Help_Center_Member_Info_Variant`,
};

const methods = {
    getTag: (key: keyof typeof TAGS) => {
        return TAGS[key] as TagsType;
    },
};

export const useTags = (
    method: keyof typeof methods,
    key: keyof typeof TAGS
) => {
    const parsingMethod = methods[method];
    return parsingMethod(key);
};
